import React from "react";
import { Box } from "@mui/material";
import { COLORS } from "components";

export const BulkActionsToolbar = ({ totalSelectedRows, totalRows, bulkActionsButtons }: { totalSelectedRows: number, totalRows: number, bulkActionsButtons: any }) => <Box
    sx={{
        display: 'flex',
        justifyContent: 'space-between',
        pr: 2,
        alignItems: 'center',
        backgroundColor: '#e5f6fd',
        width: '100%',
        gap: 2,
        marginBottom: "8px",
        borderRadius: "7px",
    }}
>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <p style={{ color: COLORS.Mainblue, padding: "0.5rem 1rem", marginTop: "0.5rem", marginBottom: "0.5rem" }} >{`${totalSelectedRows} of ${totalRows} row(s) selected`}</p>
    </Box>
    <Box sx={{ display: 'flex', gap: 1 }}>
        {bulkActionsButtons}
    </Box>
</Box>